import { useMemo } from 'react';
import { useComponentConfig } from '@namespace/cms';
import { useGetLobbyPageUrl } from '../../hooks';

export const useGameListCommonProps = () => {
  const {
    casinoType,
    showTags = true,
    showGameNames,
    showAnimation
  } = useComponentConfig();
  const lobbyPageUrl = useGetLobbyPageUrl(casinoType);

  const controls = useMemo(
    () => ({
      serviceURL: lobbyPageUrl,
      hasFavoriteButton: true
    }),
    [lobbyPageUrl]
  );
  const gamesListConfig = useMemo(
    () => ({
      showTags,
      casinoType,
      showGameNames,
      showAnimation
    }),
    [showTags, casinoType, showGameNames, showAnimation]
  );

  return { controls, config: gamesListConfig, casinoType };
};
